import { styled, type SxProps, type Theme } from "@mui/material";
import { DataGridPro, jaJP, type DataGridProProps } from "@mui/x-data-grid-pro";

import { getStickyHeaderSx } from "./DataGrid";

// 不要であったり、不変にしたり等で外から受け取らないプロパティ
type OmitProperties = "density" | "localeText";

interface IProps extends Omit<DataGridProProps, OmitProperties> {
  stickyHeader?: boolean;
}

const ChibanKaokuNumberSearchDataGrid: React.FC<IProps> = ({
  stickyHeader = false,
  ...props
}) => {
  return (
    <DataGridPro
      density="standard"
      localeText={{ ...jaJP.components.MuiDataGrid.defaultProps.localeText }}
      pagination
      {...props}
      sx={[getStickyHeaderSx(stickyHeader), props.sx ?? {}] as SxProps<Theme>}
    />
  );
};

const StyledDataGrid = styled(ChibanKaokuNumberSearchDataGrid)`
  & .MuiDataGrid-cell {
    overflow: visible;
  }

  & .MuiDataGrid-cellContent {
    overflow: visible;
  }

  // テーブルのセルをクリックしても青い枠が表示されないようにする
  & .MuiDataGrid-cell:focus-within,
  & .MuiDataGrid-cell:focus {
    outline: none !important;
  }

  // テーブルのカラムヘッダをクリックしても青い枠が表示されないようにする
  & .MuiDataGrid-columnHeader:focus-within,
  & .MuiDataGrid-columnHeader:focus {
    outline: none !important;
  }

  // テーブルヘッダーの背景色を設定
  .MuiDataGrid-columnHeaders {
    line-height: 1.5em !important;
  }

  // テーブルタイトルを通常の太さに
  .MuiDataGrid-columnHeaderTitle {
    font-weight: 700;
  }

  // 検索結果ヒット件数のセルを青色に（1件以上の場合）
  & .hit-count-cell {
    background-color: #e3f2fd;
    color: #1976d2;
    font-weight: bold;
  }

  // 検索結果ヒット件数が0件の場合は赤色に
  & .hit-count-cell-zero {
    background-color: #ffebee;
    color: #d32f2f;
    font-weight: bold;
  }
`;

export { StyledDataGrid };
